import { Divider } from '@mui/material';
import { styled } from '@mui/system';

const StyledDivider = styled(Divider)(({ theme }) => ({
  width: '100%',
  height: '1px',
  alignSelf: 'center',
  borderRadius: '5px',
  opacity: '0.5',
  backgroundColor: theme.colors.grayDividerColor,
  padding: '0',
}));

export default StyledDivider;
